module.exports = {
	"list": "findify-components-autocomplete--search-suggestions__list"
};